import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
// import { logger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import reducers from 'redux/reducers'
import thunk from 'redux-thunk'
import sagas from 'redux/sagas'
import { PUBLIC_URL } from 'utils/constants'

const history = createBrowserHistory({ basename: PUBLIC_URL })
const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)
const middlewares = [thunk, sagaMiddleware, routeMiddleware]

if (process.env.NODE_ENV === 'development' && true) {
  // middlewares.push(logger)
}
const store = createStore(reducers(history), compose(applyMiddleware(...middlewares)))
sagaMiddleware.run(sagas)

export { history, store }


